import store from "../store"

import { setToken } from "@/utils/auth.js"

async function getToken() {
    const token = window.JS ? JS.getToken() : 'b3ada7f58bb5e4c5796d078cbf1fbec3'
    const userRole = JS.getUserRole()
    const userShopID = JS.getUserShopID()
    store.commit('setState', { name: 'token', value: token })
    store.commit('setState', { name: 'userRole', value: userRole })
    store.commit('setState', { name: 'userShopID', value: userShopID })
    setToken(token)
}

export default (to, from, next) => {
    // console.log('路由拦截')
    (!store.state.token && window.JS) && getToken()
    !store.state.startRouter && store.commit('setState', {name: 'startRouter', value: to.path})
    to.meta.title && (document.title = to.meta.title)
    next()
}